import React from 'react'
import img from "../../assets/about-ad.webp"
import logo from "../../assets/footer-logo.webp"
import spinner from "../../assets/Spinner.webp"
import AdImg1 from "../../assets/Ad-1.webp"
import AdImg2 from "../../assets/Ad-2.webp"
import AdImg3 from "../../assets/Ad-3.webp"
import AdImg4 from "../../assets/Ad-4.webp"
import Slider from "react-slick"
import Carousel from '../../layout/Carousel'
import Tilt from "react-parallax-tilt"


const Advertisement = () => {

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  return (
    <div>
      <div className='about-1'>

        <div className='about-sec-1' >
          <span className='z-10' id='about-spinner'>
          <img id='about-spinner-img' src={spinner} alt='vwrap'/>
          </span>
          <Tilt glareEnable={true} tiltMaxAngleX={10} 
        tiltMaxAngleY={10} perspective={1000} 
        glareColor={"rgba(255,0,0,0)"}>

          <img id='about-ad-img' src={img} alt='vwrap'/>
        </Tilt>
        </div>

        <div id='about-sec-2' className='w-2/4'>
          <p className='pl-12 text-white'>ABOUT US</p>
          <h2 className='border-l-0'>
            WE ARE A PROMISING
            <span> 360 ADVERTISEMENT </span>
            AGENCY
          </h2>

          <p className='text-white my-8 pl-12 mr-0'>Vwrap is a Karachi based company with its operational capacity throughout Pakistan. We offer an array of diversified services to our customers equally competitive with the global standards.<br/><br/>

We are a promising 360 advertisement agency, established with an aim to provide effective quality 360 advertisement solutions to the marketiers.<br/><br/>

Vwrap is a prime platform for advertisers to maximize their return on investment as we provide you innovative and integrated brand marketing. Our sole objective is to fulfil the requirements of our clients according to their needs.</p>

         
        </div>

      </div>

       


      <div id='ad-images' className='flex my-40' >
       
      
        <img width={"25%"} src={AdImg1} alt='vwrap'/>
        <img width={"25%"} src={AdImg2} alt='vwrap'/>
        <img width={"25%"} src={AdImg3} alt='vwrap'/>
        <img width={"25%"} src={AdImg4} alt='vwrap'/>  
        <img width={"25%"} src={AdImg1} alt='vwrap'/>
        <img width={"25%"} src={AdImg2} alt='vwrap'/>
        <img width={"25%"} src={AdImg3} alt='vwrap'/>
        <img width={"25%"} src={AdImg4} alt='vwrap'/>

       </div>


      <div id='ad-carousel' >
      <div className='w-9/12 my-8'>
        <Slider {...settings}>
          <div>
          <img src={AdImg1} alt='vwrap'/>
          </div>
          <div>
          <img src={AdImg2} alt='vwrap'/>
          </div>
          <div>
          <img src={AdImg3} alt='vwrap'/>
          </div>
          <div>
          <img src={AdImg4} alt='vwrap'/>
          </div>
          
        </Slider>
      </div>
      </div>

      <div className='px-20' id='ad'>
          <div className='border-l-2 mr-12 ml-28' id='ad-div'>
            <div className='flex items-center'>
             <img className='pl-8 w-56' src={logo} id='ad-logo' alt='vwrap'/> 
             <h2 className='border-l-0' >360 ADVERTISEMENT </h2><br/>
            </div>
             <h2 style={{color:"#FBC213"}} className=' border-l-0'>SERVICES</h2>
            </div>
          </div>

     <div id='carousel' className=' justify-center'>
        <Carousel />
     </div>

     <div id='carousel-2' className='flex justify-center'>
     <div id='carousel-2-sec' className='w-2/4 my-8 mb-12'>
        <Slider {...settings}>
          <div className='slide-1'>
          <div>
          <p >
                <p>ON VEHICLE ADVERTISEMENT PLATFORM PROVIDER</p>
                <span>Vwrap takes brands street to street to cover every possible corner of the city so it’s message is seen</span>
              </p>
          </div>
          </div>
          <div  className='slide-2'>
          <div>
          <p >
                <p className='color-theme'>360 ADVERTISEMENT PLANING</p>
                <span>360°Marketing Campaign is a complete creative campaign idea across allthe brand’s marketing</span>
              </p>
          </div>
          </div>
          <div  className='slide-3'>
          <div>
          <p>
                <p className='color-theme'>OUT OF HOME ADVERTISEMENT PLATFORM PROVIDER</p>
                <span>Vwrap is a promising advertisement agency, established with an aim to provide effective quality out of home</span>
              </p>
          </div>
          </div>
          
        </Slider>
      </div>
     </div>

     <div className='flex justify-center pb-12'>
     <p id='about-btn'>Learn More</p>
     </div>


    </div>
  )
}

export default Advertisement
